import { salesGraphsConstants, userConstants } from "../constants";
import { salesChartsDebug } from "../helpers/salesChartsDebug";
import { alertActions } from "./alert.actions";
import { entityDataGenerator } from "../helpers";

export const salesGraphActions = {
  getGraphsData,
};

function getGraphsData() {
  return (dispatch) => {
    salesChartsDebug("getGraphsData: start");
    dispatch(request());
    const getGraphsSummary = entityDataGenerator.genSalesGraphsSummary();

    getGraphsSummary
      .then((graphData) => {
        salesChartsDebug("getGraphsData: API resolved", {
          type: graphData == null ? String(graphData) : typeof graphData,
          keys:
            graphData && typeof graphData === "object"
              ? Object.keys(graphData)
              : undefined,
        });
        dispatch(success(graphData));
      })
      .catch((err) => {
        salesChartsDebug("getGraphsData: API rejected", {
          message: err && err.message,
          string: String(err),
        });
        dispatch(failure(err.toString()));
        httpErrorHandler(err);
      });
  };

  function request() {
    return { type: salesGraphsConstants.SALES_GRAPHS_REQUEST };
  }
  function success(orders) {
    return { type: salesGraphsConstants.SALES_GRAPHS_SUCCESS, orders };
  }
  function failure(error) {
    return { type: salesGraphsConstants.SALES_GRAPHS_FAILURE, error };
  }
}

function httpErrorHandler(error) {
  return (dispatch) => {
    let httpStatus =
      error.response != undefined ? error.response.status : 404;
    if (httpStatus >= 500 || httpStatus == 404) {
      // Added to handle error(s)
      dispatch(alertActions.error("Network Connection Error."));
    } else if (httpStatus == 401) {
      userActions.msalLogout();
      dispatch({ type: userConstants.LOGOUT });
    } else {
      dispatch(failure(error.toString()));
      dispatch(alertActions.error(error.toString()));
    }
  };
}
